import React from "react";
import { Stack, useTheme, useMediaQuery } from "@mui/material";

import useGetClinicianClients from "hooks/api/clinician/useGetClinicianClients";
import { ANLoadingScreen } from "@answersnow/pkg-theme";
// Modules
import SummaryWeek from "components/ClinicianDashboard/SummaryWeek";
import NextAppointment from "components/ClinicianDashboard/NextAppointment/";
import AuthSchedDelivered from "components/ClinicianDashboard/AuthSchedDelivered";
import CancellationsNoShows from "components/ClinicianDashboard/CancellationsNoShows";
// import CaseloadSummary from "components/ClinicianDashboard/CaseloadSummary";
import SessionUtilization from "components/ClinicianDashboard/SessionUtilization";
import CaseloadSummary from "components/ClinicianDashboard/CaseloadSummary";
/** @typedef {import("api/typesDef").ClinicianBasicInfo} ClinicianBasicInfo */

/**
 * @component
 * @description `ClinicianDashboard` component displays the BCBA dashboard for the selected clinician.
 * @param {Object} props
 * @param {ClinicianBasicInfo} props.basicInfo - The basic information of the clinician.
 * @param {string} props.clinicianId - The id of the clinician.
 * @returns {React.ReactNode} The Dashboard component.
 */
const ClinicianDashboard = ({ basicInfo, clinicianId }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { clinicianClients, clinicianClientsLoading } = useGetClinicianClients(basicInfo?.user_id, {
    size: 100,
  });

  if (clinicianClientsLoading || !basicInfo || !clinicianId) {
    return <ANLoadingScreen />;
  }

  return (
    <Stack gap={7} p={isSmallScreen ? 5 : 9} id="clinician-dashboard-content">
      <Stack
        id="clinician-dashboard-content"
        gap={7}
        direction={{ xs: "column", lg: "row" }}
        flexWrap="wrap"
      >
        <SummaryWeek
          clinicianId={clinicianId}
          clinicianName={basicInfo?.first_name}
          clinicianUserId={basicInfo?.user_id}
          employmentType={basicInfo?.employment_type}
          isSmallScreen={isSmallScreen}
        />

        <NextAppointment
          clinicianUserId={basicInfo?.user_id}
          clinicianInfo={basicInfo}
          isSmallScreen={isSmallScreen}
          showLinkButton={false}
        />
      </Stack>

      <AuthSchedDelivered
        clinicianId={clinicianId}
        clients={clinicianClients}
        clinicianName={basicInfo?.first_name}
        isSmallScreen={isSmallScreen}
      />

      <CancellationsNoShows
        clinicianId={clinicianId}
        clients={clinicianClients}
        isSmallScreen={isSmallScreen}
      />

      <CaseloadSummary clinicianId={clinicianId} isSmallScreen={isSmallScreen} />

      <SessionUtilization clinicianId={clinicianId} isSmallScreen={isSmallScreen} />
    </Stack>
  );
};

export default ClinicianDashboard;
